import { TableHeader } from '@/components/Table'
import cx from 'classnames'
import { match } from '@/utils/pattern-match-util'
import styles from './ServiceTableHeader.module.css'

interface ServiceTableHeaderProps {
  children: string
  align: 'right' | 'left'
}

export function ServiceTableHeader({
  children,
  align,
}: ServiceTableHeaderProps) {
  return (
    <TableHeader>
      <div className={cx(styles.tableHeader, alignClassName(align))}>
        {children}
      </div>
    </TableHeader>
  )
}

function alignClassName(align: ServiceTableHeaderProps['align']) {
  return match(align, {
    left: styles.left,
    right: styles.right,
  })
}
